import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { GraphQLError } from "graphql";

interface SnackBarOption {
  duration: number;
}

@Injectable()
export class SnackBarService {
  constructor(private snackBar: MatSnackBar) {}

  public showQueryError(
    err: readonly GraphQLError[] | null,
    actionText?: string,
    optionsOverride?: SnackBarOption
  ) {
    if (err) {
      this.show(
        err.map((x) => x.message).join(","),
        actionText,
        optionsOverride
      );
    }
  }

  public showMutationError(
    err: GraphQLError,
    actionText?: string,
    optionsOverride?: SnackBarOption
  ) {
    let msg = err.message.split(":")[1];
    this.show(msg, actionText, optionsOverride);
  }

  public show(
    msg: string,
    actionText?: string,
    optionsOverride?: SnackBarOption
  ) {
    let options = Object.assign({}, this.getDefaults(), optionsOverride || {});
    actionText = actionText || "DISMISS";
    return this.snackBar.open(msg, actionText, options).onAction();
  }

  private getDefaults() {
    return {
      duration: 3000,
    };
  }
}
